import axios from 'axios';

export const fetchProjects = () => {
  return dispatch => {
    axios
      .get('https://medabi-dev-wen.onrender.com/portfolio_med')
      .then(response => {
        const data = response.data;
        dispatch(setProjects(data)); // Dispatch the action to update state
      })
      .catch(error => {
        console.error('Error fetching projects:', error);
      });
  };
};
export const fetchProject = (id) => {
  return dispatch => {
    axios
      .get(`https://medabi-dev-wen.onrender.com/portfolio_med/${id}`)
      .then(response => {
        const data = response.data;

        dispatch(setProject(data)); // Dispatch the action to update state
      })
      .catch(error => {
        console.error('Error fetching project:', error);
      });
  };
};

export const setProjects = projects => {
    return {
      type: 'SET_PROJECTS',
      payload: projects,
    };
  };
  
  export const setProject = project => {
    return {
      type: 'SET_PROJECT',
      payload: project,
    };
  };
  